import { render, staticRenderFns } from "./criminalRecordCertificates.vue?vue&type=template&id=c780a970&scoped=true&"
import script from "./criminalRecordCertificates.vue?vue&type=script&lang=js&"
export * from "./criminalRecordCertificates.vue?vue&type=script&lang=js&"
import style0 from "./criminalRecordCertificates.vue?vue&type=style&index=0&id=c780a970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c780a970",
  null
  
)

export default component.exports